import React from "react";
import { CheckCircle } from "lucide-react";
import { Link } from "react-router-dom";

export default function PagoExitoso() {
  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-gradient-to-b from-white to-blue-50">
      <div className="bg-white shadow-lg rounded-3xl p-10 max-w-md text-center">
        
        <CheckCircle className="w-20 h-20 text-green-500 mx-auto mb-6" />

        <h1 className="text-3xl font-bold text-blue-900 mb-2">
          ¡Pago exitoso!
        </h1>

        <p className="text-gray-700 mb-6 leading-relaxed">
          Tu pago ha sido validado correctamente.  
          Ya puedes revisar tu sesión desde tu panel.
        </p>

        {/* BOTÓN PRINCIPAL */}
        <Link
          to="/paciente/sesiones"
          className="inline-block bg-blue-600 text-white px-6 py-3 rounded-xl font-medium hover:bg-blue-700 transition w-full mb-3"
        >
          Ver mis sesiones
        </Link>


        {/* BOTÓN SECUNDARIO */}
        <Link
          to="/"
          className="inline-block bg-gray-200 text-blue-900 px-6 py-3 rounded-xl font-medium hover:bg-gray-300 transition w-full"
        >
          Volver al inicio
        </Link>

      </div>
    </div>
  );
}
